// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__8QIEY","rootMobile":"styles_rootMobile__qnh8B"};